import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'

export const CardColor = styled(Box)(({ theme }) => ({
  boxShadow: '0px 8px 25px rgba(0, 0, 0, 0.1)',
  borderRadius: theme.spacing(1),
  backgroundColor: theme.palette.common.white,
  display: 'flex',
  maxWidth: '256px'
}))

export const Hero = styled(Box)(({ theme }) => ({
  backgroundSize: 'cover !important',
  height: '220px',
  backgroundPosition: 'center !important',
  borderRadius: theme.spacing(2),
  boxShadow: '0px 8px 25px rgba(0, 0, 0, 0.1)'
}))
